const ErrorHandled = {
    Handled: 'handled',
    NotHandled: 'not-handled',
};
export default ErrorHandled;
//# sourceMappingURL=ErrorHandled.js.map